import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import {Link} from "react-router-dom";

export class MarketingPreferencesCarouselBanner extends React.Component {

    public render() {
        return (
            <div className="banner carousel-banner banner-content">
                <img className="banner-icon" src={`/${resourcesHelper.THEME}/img/gift_icon.svg`} alt="Gift icon"/>
                <div className="banner-text">
                    <div className="banner-title mb-3">Don't miss out!</div>
                    Get the latest tips, offers and rewards-from priority rugby tickets to exclusive discounts. <br/>
                    Just let us know how you'd like to hear from us - email, text, phone or post.
                    <p className="mt-3">
                        <Link
                            className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                            to={{pathname: "/dashboard/marketing-preferences"}}>
                            <img className="carousel-banner-arrow"
                                 src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}
                                 alt="Arrow icon"
                            />Update my marketing preferences
                        </Link>
                    </p>
                </div>
            </div>
        )
    }
}
